var _path, _g, _path2, _g2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMotoSideFill = function SvgMotoSideFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_1763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6H18.011V18H3V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.979 15.55C8.979 16.272 8.401 16.86 7.691 16.86C6.981 16.86 6.403 16.272 6.403 15.55C6.403 15.438 6.421 15.331 6.448 15.228H8.935C8.961 15.331 8.979 15.438 8.979 15.55ZM18.01 7.6C18.01 6.718 17.303 6 16.435 6H14.474C14.06 6 13.726 6.34 13.726 6.76C13.726 7.18 14.06 7.52 14.474 7.52H16.435C16.479 7.52 16.515 7.556 16.515 7.6V10.35L13.876 13.71H10.7V8.94H6.673C4.644 8.94 3 10.61 3 12.672V15.228H5.314C5.3 15.334 5.282 15.439 5.282 15.55C5.282 16.9 6.362 18 7.692 18C9.02 18 10.1 16.9 10.1 15.55C10.1 15.44 10.082 15.334 10.068 15.228H10.69L10.699 15.229H14.597L18.011 10.88V7.6H18.01Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.979 15.55C8.979 16.272 8.401 16.86 7.691 16.86C6.981 16.86 6.403 16.272 6.403 15.55C6.403 15.438 6.421 15.331 6.448 15.228H8.935C8.961 15.331 8.979 15.438 8.979 15.55ZM18.01 7.6C18.01 6.718 17.303 6 16.435 6H14.474C14.06 6 13.726 6.34 13.726 6.76C13.726 7.18 14.06 7.52 14.474 7.52H16.435C16.479 7.52 16.515 7.556 16.515 7.6V10.35L13.876 13.71H10.7V8.94H6.673C4.644 8.94 3 10.61 3 12.672V15.228H5.314C5.3 15.334 5.282 15.439 5.282 15.55C5.282 16.9 6.362 18 7.692 18C9.02 18 10.1 16.9 10.1 15.55C10.1 15.44 10.082 15.334 10.068 15.228H10.69L10.699 15.229H14.597L18.011 10.88V7.6H18.01Z",
    fill: "currentColor",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_243_1763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 6,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53 6H10.704V7.52H5.53V6Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_243_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.278 7.52H9.956C10.369 7.52 10.704 7.18 10.704 6.76C10.704 6.34 10.369 6 9.956 6H6.278C5.864 6 5.53 6.34 5.53 6.76C5.53 7.18 5.864 7.52 6.278 7.52Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.278 7.52H9.956C10.369 7.52 10.704 7.18 10.704 6.76C10.704 6.34 10.369 6 9.956 6H6.278C5.864 6 5.53 6.34 5.53 6.76C5.53 7.18 5.864 7.52 6.278 7.52Z",
    fill: "currentColor",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_243_1763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 13,
    width: 5,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.18 13.102H20.999V18H16.18V13.102Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_243_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.59 16.86C17.88 16.86 17.302 16.273 17.302 15.55C17.302 14.829 17.88 14.242 18.59 14.242C19.3 14.242 19.878 14.829 19.878 15.55C19.878 16.273 19.3 16.86 18.59 16.86ZM18.59 13.102C17.261 13.102 16.18 14.2 16.18 15.55C16.18 16.902 17.261 18 18.59 18C19.918 18 21 16.902 21 15.55C21 14.2 19.917 13.102 18.59 13.102Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.59 16.86C17.88 16.86 17.302 16.273 17.302 15.55C17.302 14.829 17.88 14.242 18.59 14.242C19.3 14.242 19.878 14.829 19.878 15.55C19.878 16.273 19.3 16.86 18.59 16.86ZM18.59 13.102C17.261 13.102 16.18 14.2 16.18 15.55C16.18 16.902 17.261 18 18.59 18C19.918 18 21 16.902 21 15.55C21 14.2 19.917 13.102 18.59 13.102Z",
    fill: "currentColor",
    fillOpacity: 0.2
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMotoSideFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "moto-side-fill.788ecb4e34745a854fe12a991dc772bc.svg";